import { render } from "./RightSection.vue?vue&type=template&id=5ad7cdc8"
import script from "./RightSection.vue?vue&type=script&lang=js"
export * from "./RightSection.vue?vue&type=script&lang=js"

import "./RightSection.vue?vue&type=style&index=0&id=5ad7cdc8&style=scss&lang=css"

import exportComponent from "/opt/build/repo/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__